import { Autocomplete as MuiAutocomplete, AutocompleteProps, TextField } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { ErrorMessage } from '../ErrorMessage'

interface Option {
  name: string
  value: string
}

// @ts-expect-error ???
type Props = AutocompleteProps & {
  name: string
  options: Option[]
}

const isOptionEqualToValue = (option: Option, value: Option) => option.value === value.value

const Autocomplete = ({ defaultValue, label, name, onChange: onChangeProp, onFocus, options, ...props }: Props) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, ...fieldProps }, fieldState: { error } }) => {
        const hasError = Boolean(error)
        const actualDefaultValue = options.find(({ value }: Option) => value === defaultValue) ?? ''

        return (
          <MuiAutocomplete
            {...props}
            defaultValue={actualDefaultValue}
            getOptionLabel={(option: Option) => option.name}
            isOptionEqualToValue={isOptionEqualToValue}
            onChange={(_, data: Option | null) => {
              const value = data ? data.value : ''

              onChange(value)

              if (onChangeProp) {
                onChangeProp(value)
              }
            }}
            options={options}
            renderInput={(params) => (
              <>
                <TextField {...params} {...fieldProps} error={hasError} label={label} onFocus={onFocus} variant="standard" />
                {hasError && <ErrorMessage message={error?.message ?? ''} />}
              </>
            )}
          />
        )
      }}
    />
  )
}

export { Autocomplete }
